import type { DateTimeSettings } from './types';
import { parseDateToTimestamp } from './parseDateToTimestamp';

/**
 * Builds a Date object from various input types
 * @param v - Input value (Date, timestamp in seconds, or ISO string)
 * @throws {Error} If the input is invalid or results in an invalid date
 */
export const buildDate = (
    v: string | number | Date,
    settings: DateTimeSettings
): Date => {
    const time = parseDateToTimestamp(v);

    // Convert seconds to milliseconds and apply offset
    let offsetCompensation = 0;

    if (settings.useTimeZoneOffset) {
        // same as: @bb-libs/helpers/dateFromEpoch.ts
        offsetCompensation = settings.timeZoneOffset * 60 * 1000;
    }

    return new Date(time + offsetCompensation);
};
